import React from "react";
import { Grid, Container } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import LoginOption from "./LoginOption";
import BankID_LOGO from "../../../images/bankID_logo.png";
import BankID_MOB_LOGO from "../../../images/bankdID_mobie_logo.png";
import { useResource } from "rest-hooks";
import BankIdResource from "../../../resources/BankIdResource";

interface ILoginSelectionProps extends RouteComponentProps {
	allowTestLogin: boolean;
}

const LoginSelection = ({ navigate, allowTestLogin }: ILoginSelectionProps) => {
	const { bankIdIframeUrl, bankIdMobileIframeUrl } = useResource(BankIdResource.detailShape(), {});

	return (
		<Container maxWidth="sm">
			<Grid container spacing={3} justify="center">
				<Grid item xs={12} sm={6}>
					<LoginOption
						logoUrl={BankID_LOGO}
						size="240px"
						onClick={() => window.location.href = bankIdIframeUrl}
					/>
				</Grid>
				{/*<Grid item xs={12} sm={6}>*/}
				{/*	<LoginOption*/}
				{/*		logoUrl={BankID_MOB_LOGO}*/}
				{/*		size="210px"*/}
				{/*		onClick={() => window.location.href = bankIdMobileIframeUrl}*/}
				{/*	/>*/}
				{/*</Grid>*/}
				{allowTestLogin && (
					<Grid item xs={12} sm={12}>
						<LoginOption
							text="Logg inn med PersonID"
							size="210px"
							onClick={() => navigate?.("ssn")}
						/>
					</Grid>
				)}
			</Grid>
		</Container>
	);
};

export default LoginSelection;
